

import {onMounted, ref} from 'vue'
import {useToast} from "primevue/usetoast";

import BookRepository from '@/services/BookRepository'
import BookResult from '@/models/bookresult.models'
import {useStore} from "vuex";
import Book from '@/models/book.models';
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import {FilterMatchMode} from "primevue/api";
import {useConfirm} from "primevue/useconfirm";

export default {
  setup() {
    const date = ref(new Date());
    const books = ref([] as BookResult[]);
    const booksDefault = ref([] as BookResult[]);
    const toast = useToast();
    const isLoading = ref(false);
    const store = useStore();
    const bookSelect = ref({} as Book);
    const edit= ref(false);
    const teams = ref({} as Team[]);
    const checkbox = ref(false);
    // const confirm = useConfirm();
    const selectStatus = ref(0);
    const status = ref([
          { label: 'Tất cả', value: '1' },
          { label: 'Chờ khám', value: '2' },
          { label: 'Đã khám', value: '3' },
      ]);
    const selectTeam = ref("");

    const select = () => {
        if(selectStatus.value == 1)
        {
            books.value = booksDefault.value;
        }
        else if(selectStatus.value == 2)
        {
            books.value = booksDefault.value.filter(x => x.checked == false);
        }
        else if(selectStatus.value == 3)
        {
            books.value = booksDefault.value.filter(x => x.checked == true);
        }
        if(selectTeam.value != "" && selectTeam.value != null)
        {
            books.value = books.value.filter(x => x.team == selectTeam.value);
        }
    }

      const onSelectTeam = () =>{
          if(selectTeam.value == null)
              books.value = booksDefault.value;
          else
              books.value = booksDefault.value.filter(x => x.team == selectTeam.value);
      }

    const loadBook = () => {
      isLoading.value = true;
      TeamRepository.getTeams()
              .then((response) => {
                teams.value = response.data;
                BookRepository.getBooks(date.value, store.state.team, store.state.permission)
                        .then(response => {
                          books.value = response.data;
                          books.value.forEach(x => {
                            teams.value.forEach(y => {
                              if(y.code == x.team) x.team = y.name;
                            });
                          });
                          booksDefault.value = books.value;
                            books.value = booksDefault.value.filter(x => x.checked == false);
                        })
                        .catch(() => {
                          toast.add({
                            severity: 'error',
                            summary: 'Thất bại',
                            detail: 'Không thể tải danh sách lịch đặt chổ.',
                            life: 1000
                          });
                        })
                        .finally(() => {
                          isLoading.value = false;
                        });
              })
              .catch();
    }

    const editBook = (id: number) => {
        BookRepository.getById(id)
            .then(response => {
                bookSelect.value = response.data;
                edit.value = true;
            })
            .catch(() => {
                toast.add({
                    severity: 'error',
                    summary: 'Thất bại',
                    detail: 'Không thể tải danh sách lịch đặt chổ.',
                    life: 1000
                });
            })
            .finally(() => {
                isLoading.value = false;
            });
    }
    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    onMounted(loadBook);

    return {
      date,
      loadBook,
      books,
      isLoading,
      bookSelect,
      editBook,
      edit,
      filters,
      clearFilter,
      initFilters,
      checkbox,
      status,
      selectStatus,
      select,
      teams,
      selectTeam,
      onSelectTeam,
    }
  }

}
